import de from "./de-DE";
import en from "./en-US";
import es from "./es-ES";
import fr from "./fr-FR";
import ja from "./ja-JP";
import ko from "./ko-KR";
import pt from "./pt-PT";
import ru from "./ru-RU";
import th from "./th-TH";
import tr from "./tr-TR";
import vi from "./vi-VN";
import zh_CN from "./zh-CN";
import zh_TW from "./zh-TW";
import { getHrefParam } from "../ultile";
import globalConfig from "../../utiles/globalConfig";

const LANG_MAP = {
  "en-US": en,
  "es-ES": es,
  "tr-TR": tr,
  "zh-CN": zh_CN,
  "zh-TW": zh_TW,
  "fr-FR": fr,
  "pt-PT": pt,
  "vi-VN": vi,
  "th-TH": th,
  "ja-JP": ja,
  "ko-KR": ko,
  "ru-RU": ru,
  "de-DE": de,
};

const LANG_TEXT = {
  "en-US": "English",
  "es-ES": "Español",
  "tr-TR": "Türkçe",
  "zh-CN": "简体中文",
  "zh-TW": "繁體中文",
  "fr-FR": "Français",
  "pt-PT": "Português",
  "vi-VN": "Tiếng Việt",
  "th-TH": "ไทย",
  "ja-JP": "日本語",
  "ko-KR": "한국어",
  "ru-RU": "Русские",
  "de-DE": "Deutsch",
};

const DEFAULT_LANG = "en-US";
export const LANGUAGE_LOCALSTORGE_NAME = "37games_page_lang";

// 匹配浏览器语言到LANG_MAP
const getBrowserLanguage = function() {
  if (window.navigator) {
    let lang = window.navigator.language || window.navigator.browserLanguage || window.navigator.systemLanguage;
    if (lang.indexOf("-") > -1) {
      let langArr = lang.split("-");
      let realLang = langArr[0].toLowerCase() + "-" + langArr[1].toUpperCase();
      return LANG_MAP[realLang] ? realLang : false;
    } else {
      let realLang = lang.toLowerCase();
      let res = "";
      for (let key in LANG_MAP) {
        let langkey = key.split("-")[0];
        if (realLang === langkey) {
          res = key;
          break;
        }
      }
      return res;
    }
  } else {
    return;
  }
};

const getLocalLang = function() {
  let localLang = globalConfig.getLclStorageItem(LANGUAGE_LOCALSTORGE_NAME);
  return localLang;
};

export default {
  language: "",
  defaultLang: DEFAULT_LANG,
  setLanguage(language) {
    this.language = language;
  },
  init() {
    var lan = getHrefParam("appLanguage") || getHrefParam("language") || getLocalLang() || getBrowserLanguage() || DEFAULT_LANG;
    this.setLanguage("ja-JP");
  },
  mapMutiples(fields, lan) {
    if (lan) {
      this.setLanguage(lan);
    }
    const LAN = LANG_MAP[this.language] || LANG_MAP[DEFAULT_LANG];
    var languages = {};
    /* 
             数组的使用方式
            languages.mapMutiples([
            "feedback",
            "cancel",
            "confirm",
            "switch"]}

            feedback 是产对的对象的字段名， 语言包的字段名也是feedback。

            对象的使用方式：
             languages.mapMutiples({
                 "feedback" : "abc"
             })

             feedback 是产对的对象的字段名，abc 是语言包的字段名。
        */
    if (fields instanceof Array) {
      for (let i = 0, len = fields.length; i < len; i++) {
        let key = fields[i];
        languages[key] = LAN[key] || LANG_MAP[DEFAULT_LANG][key];
      }
    } else {
      for (let prop in fields) {
        let mapKey = fields[prop];
        languages[prop] = LAN[mapKey] || LANG_MAP[DEFAULT_LANG][mapKey];
      }
    }

    return languages;
  },

  switch(fields, lan) {
    this.setLanguage(lan);
    const LAN = LANG_MAP[this.language] || LANG_MAP[DEFAULT_LANG];
    var languages = {};
    for (let i = 0, len = fields.length; i < len; i++) {
      let key = fields[i];
      languages[key] = LAN[key] || LANG_MAP[DEFAULT_LANG][key];
    }
    return languages;
  },
  get(fielName, lan) {
    if (lan) {
      this.setLanguage(lan);
    }
    const LAN = LANG_MAP[this.language] || LANG_MAP[DEFAULT_LANG];
    return LAN[fielName] || LANG_MAP[DEFAULT_LANG][fielName];
  },
  getLangText() {
    return LANG_TEXT;
  },
  getAll() {
    const LAN = LANG_MAP[this.language] || LANG_MAP[DEFAULT_LANG];
    return LAN;
  },
};
